/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type RewardsNav_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type Rewards_user$ref: FragmentReference;
export type Rewards_user = {|
  +isVerifiedTrade: ?boolean,
  +$fragmentRefs: RewardsNav_user$ref,
  +$refType: Rewards_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "Rewards_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "RewardsNav_user",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVerifiedTrade",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'aa3172776739dc69e0a28b1972c45cb4';
module.exports = node;
